(() => {
  let privacy;
  let integrationsLoaded = false;
  const controls = document.getElementById('ushop-browser-privacy');
  const button = controls?.querySelector('button');
  const status = controls?.querySelector('[role="status"]');
  const setStatus = key => { if (status) status.textContent = controls.dataset[key]; };
  const isOptedOut = () => navigator.globalPrivacyControl === true || privacy.currentVisitorConsent().sale_of_data === 'no';
  const permitted = () => {
    const consent = privacy.currentVisitorConsent();
    return !isOptedOut() && consent.analytics === 'yes' && consent.marketing === 'yes' && consent.preferences === 'yes' && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed() && privacy.preferencesProcessingAllowed() && privacy.saleOfDataAllowed();
  };
  const loadIntegrations = () => {
    integrationsLoaded = true;
    window.ChatraID = '5Jc722adtwQwqG6Hn';
    window.Chatra = window.Chatra || function () { (window.Chatra.q = window.Chatra.q || []).push(arguments); };
    const chat = document.createElement('script');
    chat.async = true;
    chat.src = 'https://call.chatra.io/chatra.js';
    document.head.appendChild(chat);
    window.renderBadge = () => {
      if (!permitted()) return;
      const container = document.createElement('div');
      document.body.appendChild(container);
      window.gapi.load('ratingbadge', () => {
        if (permitted()) window.gapi.ratingbadge.render(container, {merchant_id: 7533284, position: 'BOTTOM_LEFT'});
      });
    };
    const badge = document.createElement('script');
    badge.async = true;
    badge.src = 'https://apis.google.com/js/platform.js?onload=renderBadge';
    document.head.appendChild(badge);
  };
  const refresh = () => {
    if (button) button.disabled = false;
    if (isOptedOut()) setStatus('saved');
    else setStatus('ready');
    if (permitted()) {
      if (!integrationsLoaded) loadIntegrations();
    } else if (integrationsLoaded) {
      window.location.reload();
    }
  };
  const ready = () => {
    privacy = window.Shopify?.customerPrivacy;
    if (!privacy) { setStatus('error'); return; }
    document.addEventListener('visitorConsentCollected', refresh);
    button?.addEventListener('click', () => {
      button.disabled = true;
      setStatus('saving');
      privacy.setTrackingConsent({sale_of_data: false}, result => {
        if (result?.error || !isOptedOut()) {
          button.disabled = false;
          setStatus('error');
          return;
        }
        refresh();
      });
    });
    refresh();
  };
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
      if (error) { setStatus('error'); return; }
      ready();
    });
  } else {
    setStatus('error');
  }
})();
